import { render, staticRenderFns } from "./AccessRequests.vue?vue&type=template&id=1b2acd94&scoped=true"
import script from "./AccessRequests.vue?vue&type=script&lang=js"
export * from "./AccessRequests.vue?vue&type=script&lang=js"
import style0 from "./AccessRequests.vue?vue&type=style&index=0&id=1b2acd94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2acd94",
  null
  
)

export default component.exports